import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BackendServices from '../../services/BackendServices';

function HigherLogo() {
  return (
    <div className="logo">
      <img src="/logo192.png" alt="Higher Logo"></img>
    </div>
  );
}

function TableHeader() {
  return (
    <div className="table-row table-header" role="row">
      <div>Empresas/Usuários</div>
      <div>Taxa Spread Cripto</div>
      <div>Taxa em Porcentagem CashIn</div>
      <div>Taxa Fixa de CashIn</div>
      <div>Taxa em Porcentagem CashOut</div>
      <div>Taxa Fixa de CashOut</div>
      <div>Ação</div>
    </div>
  );
}

function TableRow({name, amountQrCode, taxCashIn, taxCashInFix, taxCashOut, taxCashOutFix, userId, onEdit}) {
  const handleEdit = () => {
    onEdit({
      userId,
      name,
      amountQrCode,
      taxCashIn,
      taxCashInFix,
      taxCashOut,
      taxCashOutFix
    });
  };

  return (
    <div className="table-row table-card" role="row">
      <div>{name}</div>
      <div>{amountQrCode}</div>
      <div>{taxCashIn}</div>
      <div>{taxCashInFix}</div>
      <div>{taxCashOut}</div>
      <div>{taxCashOutFix}</div>
      <div className="action-icon" title="Editar" role="button" tabIndex={0} onClick={handleEdit}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="currentColor"/>
          <path d="M20.71 7.04a1.003 1.003 0 000-1.42l-2.34-2.34a1.003 1.003 0 00-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z" fill="currentColor"/>
        </svg>
      </div>
    </div>
  );
}

const fetchTaxas = async () => {
  try {
    const response = await fetch(`https://api.production.higher.systems/v1/user/indexbaas`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar taxas:", error);
    throw error;
  }
};

const updateTaxas = async (taxData) => {
  try {
    const { data } = await BackendServices.updateBaasUser(taxData);
    return data;
  } catch (error) {
    console.error("Erro ao atualizar taxas:", error);
    throw error;
  }
};

// Componente Modal para edição de taxas
function EditTaxModal({ isOpen, onClose, empresa, onSave, loading }) {
  const [formData, setFormData] = useState({
    amountQrCode: '',
    taxCashIn: '',
    taxCashInFix: '',
    taxCashOut: '',
    taxCashOutFix: ''
  });

  // Atualizar dados do formulário quando o modal abrir
  useEffect(() => {
    if (isOpen && empresa) {
      setFormData({
        amountQrCode: empresa.amountQrCode || '',
        taxCashIn: empresa.taxCashIn || '',
        taxCashInFix: empresa.taxCashInFix || '',
        taxCashOut: empresa.taxCashOut || '',
        taxCashOutFix: empresa.taxCashOutFix || ''
      });
    }
  }, [isOpen, empresa]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const taxData = {
      amountQrCode: parseFloat(formData.amountQrCode),
      taxCashIn: parseFloat(formData.taxCashIn),
      taxCashInFix: parseFloat(formData.taxCashInFix),
      taxCashOut: parseFloat(formData.taxCashOut),
      taxCashOutFix: parseFloat(formData.taxCashOutFix)
    };
    onSave(empresa, taxData);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Editar Taxas - {empresa?.name}</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="amountQrCode">Taxa Spread Cripto:</label>
            <input
              type="number"
              id="amountQrCode"
              name="amountQrCode"
              value={formData.amountQrCode}
              onChange={handleInputChange}
              step="0.01"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="taxCashIn">Taxa em Porcentagem CashIn:</label>
            <input
              type="number"
              id="taxCashIn"
              name="taxCashIn"
              value={formData.taxCashIn}
              onChange={handleInputChange}
              step="0.01"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="taxCashInFix">Taxa Fixa de CashIn:</label>
            <input
              type="number"
              id="taxCashInFix"
              name="taxCashInFix"
              value={formData.taxCashInFix}
              onChange={handleInputChange}
              step="0.01"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="taxCashOut">
              Taxa em Porcentagem CashOut:</label>
            <input
              type="number"
              id="taxCashOut"
              name="taxCashOut"
              value={formData.taxCashOut}
              onChange={handleInputChange}
              step="0.01"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="taxCashOutFix">Taxa Fixa de CashOut:</label>
            <input
              type="number"
              id="taxCashOutFix"
              name="taxCashOutFix"
              value={formData.taxCashOutFix}
              onChange={handleInputChange}
              step="0.01"
              required
            />
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancelar
            </button>
            <button type="submit" className="save-button" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Homepage() {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);

  // Carregar dados das taxas ao montar o componente
  useEffect(() => {
    const loadTaxas = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchTaxas();
        setEmpresas(data);
      } catch (err) {
        setError("Erro ao carregar dados das taxas");
        console.error("Erro ao carregar taxas:", err);
        // Dados de fallback em caso de erro
        setEmpresas([
          { id: 1, empresa: "Higher Global Payments", amountQrCode: 100, taxCashIn: 10, taxCashInFix: 10, taxCashOut: 10, taxCashOutFix: 10 },
          { id: 2, empresa: "Higher Global Payments", amountQrCode: 100, taxCashIn: 10, taxCashInFix: 10, taxCashOut: 10, taxCashOutFix: 10 },
          { id: 3, empresa: "Higher Global Payments", amountQrCode: 100, taxCashIn: 10, taxCashInFix: 10, taxCashOut: 10, taxCashOutFix: 10 },
        ]);
      } finally {
        setLoading(false);
      }
    };

    loadTaxas();
  }, []);

  // Função para abrir modal de edição
  const handleOpenModal = (empresa) => {
    setSelectedEmpresa(empresa);
    setIsModalOpen(true);
  };

  // Função para fechar modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedEmpresa(null);
  };

  // Função utilitária para normalizar o identificador
  const normalizeUserId = (rawId) => {
    if (rawId === undefined || rawId === null) return rawId;
    const onlyFirstPart = String(rawId).split(':')[0];
    return onlyFirstPart.trim();
  };

  // Função para atualizar taxas
  const handleUpdateTaxas = async (empresa, taxData) => {
    try {
      setLoading(true);
      // Monta payload completo conforme API (mantendo campos conhecidos)
      const payload = {
        userId: empresa?.userId ? Number(normalizeUserId(empresa.userId)) : 0,
        email: empresa?.email || '',
        taxCashIn: taxData.taxCashIn,
        taxCashOut: taxData.taxCashOut,
        taxCashInFix: taxData.taxCashInFix,
        taxCashOutFix: taxData.taxCashOutFix,
        taxCashInTed: empresa?.taxCashInTed ?? 0,
        taxCashOutTed: empresa?.taxCashOutTed ?? 0,
        taxCashInFixTed: empresa?.taxCashInFixTed ?? 0,
        taxCashOutFixTed: empresa?.taxCashOutFixTed ?? 0,
        taxCashOutTicket: empresa?.taxCashOutTicket ?? 0,
        taxCashOutFixTicket: empresa?.taxCashOutFixTicket ?? 0,
        taxQrCodeQtt: empresa?.taxQrCodeQtt ?? 0,
        amountQrCode: taxData.amountQrCode,
        typeTax: empresa?.typeTax || '',
        name: empresa?.name || '',
        partner: empresa?.partner || '',
        doc: empresa?.doc || '',
        rejection: empresa?.rejection || '',
        companyType: empresa?.companyType || '',
        businessCity: empresa?.businessCity || '',
        businessNeighborhood: empresa?.businessNeighborhood || '',
        businessNumber: empresa?.businessNumber || '',
        businessPostalCode: empresa?.businessPostalCode || '',
        businessState: empresa?.businessState || '',
        businessStreet: empresa?.businessStreet || '',
        tradingName: empresa?.tradingName || '',
        businessName: empresa?.businessName || '',
        businessEmail: empresa?.businessEmail || '',
        documentNumber: empresa?.documentNumber || '',
        contactNumber: empresa?.contactNumber || ''
      };

      await updateTaxas(payload);
      // Feedback não intrusivo
      window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'success', message: 'Taxas atualizadas com sucesso!' } }));

      // Recarregar dados após atualização
      const updatedData = await fetchTaxas();
      setEmpresas(updatedData);

      // Fechar modal após sucesso
      handleCloseModal();
    } catch (err) {
      window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'error', message: 'Erro ao atualizar taxas. Tente novamente.' } }));
      console.error("Erro ao atualizar taxas:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="page">
      <style>{`
        :root {
          --bg: #F8FAFC;
          --card: #ffffff;
          --shadow: 0 4px 12px rgba(0,0,0,0.05);
          --shadow-hover: 0 8px 25px rgba(0,0,0,0.1);
          --text: #0F172A;
          --muted: #475569;
          --green: #10B981;
          --green-light: #D1FAE5;
          --border: #E2E8F0;
          --border-light: #F1F5F9;
        }

        html, body, #root { height: 100%; }
        body {
          margin: 0;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          background: var(--bg);
          color: var(--text);
          line-height: 1.6;
          font-size: 16px;
          font-weight: 400;
        }

        .page {
          min-height: 100%;
          display: flex;
          flex-direction: column;
          gap: 0;
        }

        .header {
          background: var(--card);
          border-bottom: 1px solid var(--border-light);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 24px 32px;
          box-shadow: var(--shadow);
        }

        .logo {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 800;
          font-size: 24px;
          color: var(--green);
          letter-spacing: -0.5px;
        }

        .logo img {
          width: 40px;
          height: 40px;
          object-fit: contain;
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .logo img:hover {
          transform: scale(1.05);
        }

        .profile {
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          padding: 8px 16px;
          border-radius: 12px;
          transition: background-color 0.2s ease;
        }

        .profile:hover {
          background: var(--green-light);
        }

        .profile .avatar {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: var(--green-light);
          display: grid;
          place-items: center;
          box-shadow: var(--shadow);
          transition: transform 0.2s ease;
        }

        .profile:hover .avatar {
          transform: scale(1.05);
        }

        .profile span {
          color: var(--text);
          font-weight: 700;
          font-size: 16px;
        }

        .content {
          padding: 32px;
          flex: 1;
        }

        .page-title {
          font-size: 32px;
          font-weight: 800;
          color: var(--text);
          margin-bottom: 12px;
          letter-spacing: -0.5px;
        }

        .page-subtitle {
          font-size: 18px;
          color: var(--muted);
          margin-bottom: 32px;
          font-weight: 500;
        }

        .table {
          display: flex;
          flex-direction: column;
          gap: 0;
          background: var(--card);
          border-radius: 16px;
          box-shadow: var(--shadow);
          overflow: hidden;
          border: 1px solid var(--border-light);
          max-height: 70vh;
          overflow-y: auto;
        }

        .table-row {
          display: grid;
          align-items: center;
          grid-template-columns: 2.2fr repeat(5, 1.5fr) 0.6fr;
          gap: 20px;
          padding: 20px 24px;
          transition: all 0.2s ease;
        }

        .table-header {
          background: var(--green-light);
          color: var(--text);
          font-weight: 700;
          font-size: 16px;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          border-bottom: 1px solid var(--border);
        }

        .table-card {
          background: var(--card);
          border-bottom: 1px solid var(--border-light);
        }

        .table-card:last-child {
          border-bottom: none;
        }

        .table-card:hover {
          background: #FAFBFC;
          transform: translateY(-1px);
          box-shadow: var(--shadow-hover);
        }

        .table-card > div {
          font-weight: 600;
          font-size: 16px;
          color: var(--text);
        }

        .action-icon {
          display: grid;
          place-items: center;
          cursor: pointer;
          padding: 10px;
          border-radius: 10px;
          transition: all 0.2s ease;
          color: var(--muted);
        }

        .action-icon:hover {
          background: var(--green-light);
          color: var(--green);
          transform: scale(1.1);
        }

        .loading-message, .error-message {
          text-align: center;
          padding: 40px 20px;
          background: var(--card);
          border-radius: 16px;
          box-shadow: var(--shadow);
          margin-bottom: 24px;
          border: 1px solid var(--border-light);
        }

        .loading-message {
          color: var(--green);
          font-weight: 700;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }

        .loading-spinner {
          width: 24px;
          height: 24px;
          border: 3px solid var(--green-light);
          border-top: 3px solid var(--green);
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .error-message {
          color: #EF4444;
          font-weight: 700;
          font-size: 18px;
          background: #FEF2F2;
          border-color: #FECACA;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal-content {
          background: var(--card);
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
          width: 90%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #e5e7eb;
        }

        .modal-header h2 {
          margin: 0;
          color: var(--text);
          font-size: 1.5rem;
          font-weight: 700;
        }

        .close-button {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: var(--muted);
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: background-color 0.2s;
        }

        .close-button:hover {
          background-color: #f3f4f6;
        }

        .modal-form {
          padding: 24px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: var(--text);
          font-size: 16px;
        }

        .form-group input {
          width: 100%;
          padding: 12px 16px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          transition: border-color 0.2s, box-shadow 0.2s;
          box-sizing: border-box;
        }

        .form-group input:focus {
          outline: none;
          border-color: var(--green);
          box-shadow: 0 0 0 3px rgba(47, 191, 100, 0.1);
        }

        .modal-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          margin-top: 24px;
          padding-top: 20px;
          border-top: 1px solid #e5e7eb;
        }

        .cancel-button, .save-button {
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          border: none;
          font-size: 16px;
        }

        .cancel-button {
          background: #f3f4f6;
          color: var(--text);
        }

        .cancel-button:hover {
          background: #e5e7eb;
        }

        .save-button {
          background: var(--green);
          color: white;
        }

        .save-button:hover:not(:disabled) {
          background: #26a854;
        }

        .save-button:disabled {
          background: #9ca3af;
          cursor: not-allowed;
        }

        /* Scrollbar personalizada */
        .content::-webkit-scrollbar,
        .table::-webkit-scrollbar {
          width: 8px;
        }

        .content::-webkit-scrollbar-track,
        .table::-webkit-scrollbar-track {
          background: var(--border-light);
          border-radius: 4px;
        }

        .content::-webkit-scrollbar-thumb,
        .table::-webkit-scrollbar-thumb {
          background: var(--green);
          border-radius: 4px;
          transition: background 0.2s ease;
        }

        .content::-webkit-scrollbar-thumb:hover,
        .table::-webkit-scrollbar-thumb:hover {
          background: #26a854;
        }

        /* Para Firefox */
        .content,
        .table {
          scrollbar-width: thin;
          scrollbar-color: var(--green) var(--border-light);
        }
      `}</style>

      <header className="header">
        <HigherLogo />
        <div className="profile">
          <div className="avatar" aria-hidden>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="4" stroke="#2FBF64" strokeWidth="2"/>
              <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="#2FBF64" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <span>Perfil</span>
        </div>
      </header>

      <section className="content">
        <div className="page-title">Dashboard de Taxas</div>
        <div className="page-subtitle">Gerencie as taxas e limites das empresas</div>

        <div style={{ display: "flex", gap: 12, marginBottom: 24 }}>
          <Link to="/whitelist">
            <button
              style={{
                padding: "10px 16px",
                borderRadius: 8,
                background: "#10B981",
                color: "#fff",
                fontWeight: 700,
                border: 0,
                cursor: "pointer"
              }}
            >
              Liberar Cadastro
            </button>
          </Link>

          <Link to="/resubmissions">
            <button
              style={{
                padding: "10px 16px",
                borderRadius: 8,
                background: "#0284C7",
                color: "#fff",
                fontWeight: 700,
                border: 0,
                cursor: "pointer"
              }}
            >
              Reenvio de Documentos
            </button>
          </Link>

          <Link to="/iugu-onboarding">
            <button
              style={{
                padding: "10px 16px",
                borderRadius: 8,
                background: "#1C787E",
                color: "#fff",
                fontWeight: 700,
                border: 0,
                cursor: "pointer"
              }}
            >
              Enviar cadastro para Iugu
            </button>
          </Link>
        </div>

        {loading && (
          <div className="loading-message">
            <div className="loading-spinner"></div>
            Carregando dados das taxas...
          </div>
        )}

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {!loading && (
          <div className="table" role="table" aria-label="Taxas e limites">
            <TableHeader />
            {empresas.map((item, index) => (
              <TableRow
                key={item.id || index}
                {...item}
                onEdit={handleOpenModal}
              />
            ))}
          </div>
        )}
      </section>

      {/* Modal de Edição */}
      <EditTaxModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        empresa={selectedEmpresa}
        onSave={handleUpdateTaxas}
        loading={loading}
      />
      {/* Toast container */}
      <div id="toast-container" aria-live="polite" aria-atomic="true" style={{position: 'fixed', right: 16, bottom: 16, zIndex: 1100}}></div>
      <script dangerouslySetInnerHTML={{__html: `
        (function(){
          const container = document.getElementById('toast-container');
          if (!container) return;
          window.addEventListener('toast', function(e){
            const { type, message } = e.detail || {};
            const toast = document.createElement('div');
            toast.setAttribute('role','status');
            toast.style.cssText = 'min-width:240px;max-width:360px;margin-top:8px;padding:12px 14px;border-radius:8px;color:#0f172a;background:'+(type==='success'?'#dcfce7':'#fee2e2')+';box-shadow:0 4px 12px rgba(0,0,0,.1);border:1px solid ' + (type==='success'?'#bbf7d0':'#fecaca');
            toast.textContent = message || '';
            container.appendChild(toast);
            setTimeout(function(){ toast.style.opacity='0'; toast.style.transition='opacity .3s'; }, 2500);
            setTimeout(function(){ container.removeChild(toast); }, 3000);
          });
        })();
      `}} />
    </main>
  );
}

export default Homepage;


